import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguagesService } from './languages.service';

@Pipe({
    name: 'languageDisplay',
    standalone: false,
})
export class LanguageDisplayPipe implements PipeTransform {
    private languagesService = inject(LanguagesService);

    /**
     * Transforms a language code like 'en' to a formatted display like 'English (en)'
     */
    transform (languageCode: string | null | undefined): string {
        if (!languageCode) {
            return 'Unknown';
        }

        try {
            languageCode = languageCode.replace('-', '_'); // Normalize code format
            const fullLanguageName = this.languagesService.getLanguage(languageCode as any);
            if (!fullLanguageName || fullLanguageName === languageCode) {
                // If no transformation found, just capitalize the code
                return languageCode.toUpperCase();
            }

            // Remove existing parentheses content from full name and add original code
            const cleanName = fullLanguageName.replace(/\s*\([^)]*\)/g, '').trim();
            return `${cleanName} (${languageCode})`;
        } catch (error) {
            // Fallback for invalid language codes
            return languageCode.toUpperCase();
        }
    }
}

@Pipe({
    name: 'languageDisplayArray',
    standalone: false,
})
export class LanguageDisplayArrayPipe implements PipeTransform {
    private languageDisplayPipe = new LanguageDisplayPipe();

    /**
     * Formats an array of language codes for display
     */
    transform (languages: string[] | null | undefined): string {
        if (!languages || languages.length === 0) {
            return 'No languages detected';
        }

        return languages.map(lang => this.languageDisplayPipe.transform(lang)).join(', ');
    }
}
